import {collection, getCountFromServer} from "firebase/firestore";
import {db} from '../config/firebase';

const getRecipeLikesCount = async (recipeId) => {
    if (!recipeId) return 0;
    try {
        const col = collection(db, "recetas", recipeId, "likes");
        const snapshot = await getCountFromServer(col);
        return snapshot.data().count || 0;
   } catch (e) {
        console.error("Error obteniendo likes:", e);
        return 0;
   }
};

export default getRecipeLikesCount;